import { render } from "./users.vue?vue&type=template&id=4b3b4de8&scoped=true&ts=true"
import script from "./users.vue?vue&type=script&lang=ts"
export * from "./users.vue?vue&type=script&lang=ts"

import "./users.vue?vue&type=style&index=0&id=4b3b4de8&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4b3b4de8"]])

export default __exports__